import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { QuizService } from '../../../services/quiz/quiz.service';
import { MyHostQuizReport, QuizReportType } from '../../../interfaces/quiz';

@Component({
  selector: 'mbti-ideal-type-select',
  templateUrl: './mbti-ideal-type-select.component.html',
  styleUrls: ['./mbti-ideal-type-select.component.scss'],
})
export class MbtiIdealTypeSelectComponent implements OnInit {
  constructor(private quizService: QuizService) {
  }

  itemList: MyHostQuizReport[] = [];
  cursor: string | null | undefined;
  selectedItem: MyHostQuizReport | undefined;
  @Output() onClickMbtiIdealTypeCard = new EventEmitter<MyHostQuizReport>();
  @Output() onClickCreateNewMbtiIdealType = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<MyHostQuizReport>();

  ngOnInit() {
    this.itemList = [];
    this.cursor = undefined;
    this.loadMbtiIdealTypeList();
  }

  onClickCard(item: MyHostQuizReport): void {
    this.selectedItem = item;
    this.onClickMbtiIdealTypeCard.emit(item);
  }

  onClickCreateNew(): void {
    this.onClickCreateNewMbtiIdealType.emit();
  }

  async onClickNext(): Promise<void> {
    if (this.selectedItem === undefined) return;
    this.onSubmit.emit(this.selectedItem);
  }

  private loadMbtiIdealTypeList(): void {
    if (this.cursor === null) {
      return;
    }
    this.quizService.getMyHostQuizReportList(null, this.cursor ?? null, 10, [QuizReportType.IDEAL_TYPE, QuizReportType.MBTI_IDEAL_TYPE]).subscribe((res) => {
      this.itemList.push(...res.data);
      if (this.cursor === undefined && this.itemList.length > 0) {
        this.selectedItem = this.itemList[0];
      }
      this.cursor = res.cursor ?? null;
    });
  }
}
